import type { HTMLAttributes } from 'react';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Add a subtle shadow on hover (for interactive cards). */
  hoverable?: boolean;
}

/**
 * Surface card: white background, hairline border, large radius.
 */
export function Card({ hoverable = false, className = '', ...rest }: CardProps) {
  return (
    <div
      className={[
        'bg-[var(--color-surface)] border border-[var(--color-border)] rounded-xl',
        hoverable ? 'transition-shadow hover:shadow-sm' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    />
  );
}
